import { z } from 'zod'
import {
  contentDataSchema,
  eventDataSchema,
  productDataSchema,
} from '../common.schema'

export const ImpressionSchema = z.object({
  event: z.literal('impression'),

  event_data: eventDataSchema,
  content_data: contentDataSchema.optional(),
  product_data: productDataSchema.optional(),
})

export type ImpressionEvent = z.infer<typeof ImpressionSchema>
